import {Slot} from "../../../../../server/src/base/entities/leasing/calendar/Slot";
import {ICurrentVan} from "../../domain/leasing/ICurrentVan";
import {Leasing} from "../../../../../server/src/base/entities/leasing/Leasing";

export class PriceComputation {

    private currentVan:ICurrentVan;

    constructor(currentVan: ICurrentVan) {
        this.currentVan = currentVan;
    }

    public Compute(slots: Array<Slot>, nbKm:number): number{
        let leasing:Leasing = this.currentVan.Value().leasing;

        let nbDays = this.NbDays(slots);
        let nbHalfDays = this.NbHalfDays(slots);
        let totalDays = this.NbTotalDays(slots);
        if(totalDays == 0)
            totalDays += 1;

        let leasingPrice:number = nbDays * leasing.pricePerDay;
        leasingPrice += nbHalfDays * leasing.pricePerHalfDay;
        let nbAdditionalKm = nbKm - (totalDays * 150);
        let kmPrice = nbAdditionalKm * leasing.pricePerKm;
        if(kmPrice < 0){
            kmPrice = 0;
        }

        let finalPrice = leasingPrice + kmPrice;
        return Math.round(finalPrice * 100) / 100;
    }

    public NbTotalDays(slots:Array<Slot>){
        return this.NbDays(slots) + this.NbHalfDays(slots);
    }

    private NbHalfDays(slots: Array<Slot>):number{
        return slots.length - (this.NbDays(slots) * 2);
    }

    private NbDays(slots: Array<Slot>):number{
        let counter:number = 0;
        for(let slot1 of slots){
            for(let slot2 of slots){
                if(slot1.SameDay(slot2)){
                    counter++;
                }
            }
        }
        return counter/2;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/leasing/PriceComputation.ts